import { FunctionComponent } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import BookingTypeSelector from "../../../components/Reports/CapacityFilter/DateAndTypeSelector/booking-type-selector.partial";
import type { BookingType } from "../../Booking-Form/typings/booking-inputs";
import { MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX } from "../utils/management-toolbar.constants";
import { ManagementToolbarField } from "./ManagementToolbarField";

const BOOKING_TYPE_LABEL_ID = "management-booking-type-field-label";

type ManagementBookingTypeToggleProps = {
  value: BookingType;
  onChange: (bookingType: BookingType) => void;
};

/**
 * Capacity-style booking type toggle for Management location detail filters.
 * Sized to match other toolbar controls.
 */
export const ManagementBookingTypeToggle: FunctionComponent<ManagementBookingTypeToggleProps> = ({
  value,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <ManagementToolbarField label={t("Booking type")} labelId={BOOKING_TYPE_LABEL_ID}>
      <Box
        sx={{
          "& .MuiToggleButtonGroup-root": {
            mr: "0 !important",
            height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
            width: "100%"
          },
          "& .MuiToggleButton-root": {
            flex: 1,
            minWidth: 0,
            height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
            px: 0.75,
            py: 0
          }
        }}
      >
        <BookingTypeSelector
          typToggle={value}
          setTypToggle={onChange}
          onEnableFetch={onChange}
          iconSize="22px"
          ariaLabelledBy={BOOKING_TYPE_LABEL_ID}
        />
      </Box>
    </ManagementToolbarField>
  );
};
